import { FormItem } from "@/components/ui/form";
import React, { useRef, useState } from "react";
import Map from "@/components/form-viewer/Map";
import { LatLngExpression } from "leaflet";
import * as L from "leaflet";
import MapEventLayer from "./utils/MapEventLayer";
type LocationViewerProps = {
  title: string;
  selectedLocation: number[] | undefined;
};
const LocationViewer = ({
  title,
  selectedLocation
}: LocationViewerProps) => {
  const [zoom, setZoom] = useState(17);
  const markerRef = useRef<L.Marker>();
  const markerGroupsRef = useRef<L.LayerGroup>();
  return <div data-sentry-component="LocationViewer" data-sentry-source-file="LocationViewer.tsx">
      <div className="flex items-center gap-2">
        <FormItem data-sentry-element="FormItem" data-sentry-source-file="LocationViewer.tsx">{title}</FormItem>
      </div>

      <div className="relative h-[60vh] w-full">
        <Map center={selectedLocation as LatLngExpression | undefined} zoom={zoom} maxZoom={17} markerZoomAnimation={true} style={{
        width: "100%",
        height: "100%"
      }} data-sentry-element="Map" data-sentry-source-file="LocationViewer.tsx">
          {({
          TileLayer
        }) => <>
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' />
              <MapEventLayer type={undefined} markerRef={markerRef} markerGroupsRef={markerGroupsRef} setZoom={setZoom} locationPolygon={undefined} disabled={true} />
            </>}
        </Map>
      </div>
    </div>;
};
export default LocationViewer;